import { ApiPlatform } from '@/api/types';
import { Container } from '@/blocks/components/Container';
import { AssetSearch, assetSearchCentered } from '@/blocks/components/Controls/Autocomplete/AssetSearch';
import { useSignup } from '@/blocks/components/PlatformLink';

export function CryptoFuturesFeesAllMarketsSearch() {
  const { openSignupWithAsset } = useSignup();
  return (
    <div>
      <Container>
        <AssetSearch
          className={assetSearchCentered}
          platform={ApiPlatform.FX}
          onChange={(_, option) => openSignupWithAsset(option)}
        />
      </Container>
    </div>
  );
}
